var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Datepicker"},[_c('b-form-datepicker',{attrs:{"id":(_vm.id + "-datepicker"),"placeholder":_vm.placeholder,"date-format-options":{
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },"state":_vm.isValid,"start-weekday":"1","max":_vm.max,"min":_vm.min},on:{"input":_vm.onSelectDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }